import { Anchor } from "@atlassiansox/bxp-content-framework";

import {
    AnalyticsAttributesProvider,
    useAnalytics,
    useAnalyticsAttributes,
    LogoTrello,
    Column,
    Container,
    Row
} from "../../components";
import { UiSplitSectionModel } from "../../models";
import { renderViewModel, renderViewModels } from "../../render-view-model";
import { BackgroundFieldValue } from "../../styles";

import {
    SectionWrapper,
    SectionLeft,
    SectionRight
} from "./UiSplitSection.styles";

type UiSplitSectionProps = {
    readonly model: UiSplitSectionModel;
};

const UiSplitSection = ({ model }: UiSplitSectionProps) => {
    const {
        entryTitle,
        useEyebrowLogo,
        columnsLeft = [],
        columnsRight = [],
        backgroundLeft = null,
        backgroundRight = null,
        footer
    } = model.content;
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();

    return (
        <>
            <SectionWrapper>
                <SectionLeft
                    background={backgroundLeft as BackgroundFieldValue}
                >
                    <header>
                        <Container>
                            <Row>
                                <Column xs={{ align: "left" }}>
                                    <Anchor
                                        href="/home"
                                        onClick={() =>
                                            sendTrackEvent(
                                                "clickedUiSplitSectionNavLogo",
                                                {
                                                    ...analyticsAttributes,
                                                    event: "clicked",
                                                    eventComponent: "logo",
                                                    label: "Trello logo",
                                                    labelEnglish: "Trello logo",
                                                    href: "/home"
                                                }
                                            )
                                        }
                                        testId="logo_link"
                                    >
                                        <LogoTrello
                                            height={useEyebrowLogo ? 42 : 25}
                                            appearance="blue"
                                            eyebrow={useEyebrowLogo}
                                        />
                                    </Anchor>
                                </Column>
                            </Row>
                        </Container>
                    </header>
                    <Container>
                        <Row>
                            <AnalyticsAttributesProvider
                                value={{
                                    eventContainer: model.type,
                                    labelEnglish: entryTitle
                                }}
                            >
                                {renderViewModels(columnsLeft)}
                            </AnalyticsAttributesProvider>
                        </Row>
                    </Container>
                    {footer && renderViewModel(footer)}
                </SectionLeft>
                <SectionRight
                    background={backgroundRight as BackgroundFieldValue}
                >
                    <Container>
                        <Row>
                            <AnalyticsAttributesProvider
                                value={{
                                    eventContainer: model.type,
                                    labelEnglish: entryTitle
                                }}
                            >
                                {renderViewModels(columnsRight)}
                            </AnalyticsAttributesProvider>
                        </Row>
                    </Container>
                </SectionRight>
            </SectionWrapper>
            {footer && renderViewModel(footer)}
        </>
    );
};

export default UiSplitSection;
